import script from "./CalendarMeeting.vue?vue&type=script&setup=true&lang=js"
export * from "./CalendarMeeting.vue?vue&type=script&setup=true&lang=js"

import "./CalendarMeeting.vue?vue&type=style&index=0&id=50bcbac5&lang=css"

const __exports__ = script;

export default __exports__